module.exports = __webpack_public_path__ + "img/2.6_About-Us_Key-Partner_4_NDARC.8e2a10ecc3463529d3cae6935e2c1e77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.6_About-Us_Key-Partner_4_NDARC.png
// module id = 781
// module chunks = 0